import axios from 'axios';
import apiConfig from '../../api.config';

export default async function getHBXChannelHotelFields(hotelId, channelId) {
  const {
    host,
    URIs: { hbxChannelHotelFields },
  } = apiConfig;

  const uri = `${host}${hbxChannelHotelFields}`
    .replace(':hotelId', hotelId)
    .replace(':channelId', channelId);

  return await axios.get(uri).then(res => res.data);
}
